package org.solyton.solawi.bid.module.banking.`data`.sepa.message

import kotlin.String
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.banking.`data`.download.Download

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaMessageString.version]
 */
@ReadWrite
public val version: Lens<SepaMessageString, SepaMessageVersion> by lazy {
      Lens(
        get = { whole -> whole.version },
        set = { part -> { whole -> whole.copy(version = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaMessageString.version]
 */
@ReadWrite
public fun SepaMessageString.version(`set`: SepaMessageVersion.() -> SepaMessageVersion):
    SepaMessageString = copy(version = set(version))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaMessageString.message]
 */
@ReadWrite
public val message: Lens<SepaMessageString, String> by lazy {
      Lens(
        get = { whole -> whole.message },
        set = { part -> { whole -> whole.copy(message = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaMessageString.message]
 */
@ReadWrite
public fun SepaMessageString.message(`set`: String.() -> String): SepaMessageString = copy(message =
    set(message))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaMessageString.download]
 */
@ReadWrite
public val download: Lens<SepaMessageString, Download> by lazy {
      Lens(
        get = { whole -> whole.download },
        set = { part -> { whole -> whole.copy(download = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaMessageString.download]
 */
@ReadWrite
public fun SepaMessageString.download(`set`: Download.() -> Download): SepaMessageString =
    copy(download = set(download))
